import Immutable from 'immutable'

const initialState = Immutable.Map({}).set('Information', new Immutable.Map({})).set('SearchBuzon', new Immutable.Map({}))

/* Types */
export const ACTION_INFORMATION_COMPONENT = 'ACTION_INFORMATION_COMPONENT'
export const ACTION_SEARCH_COMPONENT = 'ACTION_SEARCH_COMPONENT'

/* Reducer */
export default (state = initialState, action) => {

  switch (action.type) {

    case ACTION_INFORMATION_COMPONENT:
      return state.set('Information', new Immutable.Map(action.Obj))
    case ACTION_SEARCH_COMPONENT:
      return state.set('SearchBuzon', new Immutable.Map(action.Obj))
    default:
      return state;
  }
}

/* Action Creators */

export const setInformation = (form) => {
  return (dispatch) => {
    dispatch({type: ACTION_INFORMATION_COMPONENT, Obj: form})
  }
}

export const setClearInformation = () => {
  return (dispatch) => {
    dispatch({type: ACTION_INFORMATION_COMPONENT, Obj: {}})
  }
}

export const setSearchBuzon = (form) => {

  return (dispatch) => {
    dispatch({type: ACTION_SEARCH_COMPONENT, Obj: form})
  }
}




// WEBPACK FOOTER //
// ./src/modules/InformationComponent/index.js